import { React, useContext, classNames } from '@digsup/core-ui';
import PropTypes from 'prop-types';
import { List } from '@digsup/components-list';
import { Icon } from '@digsup/components-icon';
import { StepsContext } from './StepsContext';
import './StepsItem.scss';

const cx = classNames;

export const StepsItem = ({ title, status, onClick, className, ...props }) => {
  const { variant, icon } = useContext(StepsContext);

  const classes = cx(
    'c-steps-item',
    {
      [`c-steps-item--${status}`]: status,
      [`c-steps-item--${variant}`]: variant,
      [`c-steps-item--${icon}`]: icon,
      'c-steps-item--clickable': onClick,
    },
    className,
  );

  return (
    <List.Item>
      <div
        className={classes}
        role={onClick ? 'button' : 'presentation'}
        onClick={onClick}
        {...props}>
        <div className="c-steps-item__icon-wrap">
          <Icon
            name={icon}
            shape="round"
            className="c-steps-item__icon c-steps-item__icon--done"
          />
          <Icon
            name="arrow-right-bold"
            shape="round"
            className="c-steps-item__icon c-steps-item__icon--current"
          />
        </div>
        <div className="c-steps-item__title">{title}</div>
      </div>
    </List.Item>
  );
};

StepsItem.propTypes = {
  title: PropTypes.string,
  status: PropTypes.oneOf(['done', 'current', 'wait']),
  onClick: PropTypes.func,
  className: PropTypes.string,
};

StepsItem.defaultProps = {
  status: 'wait',
  className: '',
};
